/**
 * defa.collections.heatingswitchs
 * A Collection of HeatingSwitchs
 * @version 1.2.0
 */
import HeatingSwitch from './model-heating-switch';

const HeatingSwitchs = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : HeatingSwitch,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

} );


export default HeatingSwitchs